<template>
	<div class="personSet_page">
		<div class="info_content">
			<div class="info_content_main">
				<div class="info_content_main_left">
					<ul>
					<li>用户名/Username</li>
					<li>电子邮件/Email</li>
					<li>移动电话/Mobile*</li>
					<li>邮寄地址/MailingAddress*</li>
					</ul>
				</div>
				<div class="info_content_main_right">
					<ul>
					<li>
						<label v-if="edit_item != 'userName'"><p>{{user_info.userName}}</p><button @click="chang_edit('userName')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'userName'}" v-model="user_info.userName"><button @click="saveUpdate('userName')">保存</button></label>
					</li>
					<li>
						<label v-if="edit_item != 'email'"><p>{{user_info.email}}</p><button @click="chang_edit('email')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'email'}" v-model="user_info.email"><button @click="saveUpdate('email')">保存</button></label>
					</li>
					<li>
						<label v-if="edit_item != 'mobile'"><p>{{user_info.mobile}}</p><button @click="chang_edit('mobile')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'mobile'}" v-model="user_info.mobile"><button @click="saveUpdate('mobile')">保存</button></label>
					</li>
					<li>
						<label v-if="edit_item != 'mailingAddress'"><p>{{user_info.mailingAddress}}</p><button @click="chang_edit('mailingAddress')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'mailingAddress'}" v-model="user_info.mailingAddress"><button @click="saveUpdate('mailingAddress')">保存</button></label>
					</li>
					</ul>
				</div>
			</div>
			<div class="info_content_main">
				<div class="info_content_main_left">
					<ul>
					<li>职业阶段/Occupation stage</li>
					<label v-if="occupation=='student'">
					<li>所在院校/Universities*</li>
					<li>所学专业/Major*</li>
					<li>入学时间/Time of Enrollment*</li>
					<li>学位阶段/Study Level*</li>
					</label>
					<label v-else>
					<li>工作单位/Company*</li>
					<li>职业/Occupation*</li>
					<li>毕业院校/Graduated from*</li>
					<li>毕业时间/Time of graduation*</li>
					<li>毕业专业/Major*</li>
					<li>学位/Academic degree*</li>
					</label>
					</ul>
				</div>
				<div class="info_content_main_right">
					<ul>
					<li class="info_content_main_occupation">
						<p :class="{info_occupation_active:occupation=='student'}">学生</p>
						<p :class="{info_occupation_active:occupation !='student'}">在职</p>
					</li>
					<label v-if="occupation=='student'">
					<li>
						<label v-if="edit_item != 'universities'"><p>{{user_info.universities}}</p><button @click="chang_edit('universities')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'universities'}" v-model="user_info.universities"><button @click="saveUpdate('universities')">保存</button></label>
					</li>
					<li>
						<label v-if="edit_item != 'major'"><p>{{user_info.major}}</p><button @click="chang_edit('major')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'major'}" v-model="user_info.major"><button @click="saveUpdate('major')">保存</button></label>
					</li>
					<li>
						<label v-if="edit_item != 'time_enrollment'"><p>{{user_info.time_enrollment}}</p><button @click="chang_edit('time_enrollment')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'time_enrollment'}" v-model="user_info.time_enrollment"><button @click="saveUpdate('mailingAddress')">保存</button></label>
					</li>
					<li>
						<label v-if="edit_item != 'studey_level'"><p>{{user_info.studey_level}}</p><button @click="chang_edit('studey_level')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'studey_level'}" v-model="user_info.studey_level"><button @click="saveUpdate('studey_level')">保存</button></label>
					</li>
					</label>
					<label v-else>
					<li>
						<label v-if="edit_item != 'company'"><p>{{user_info.company}}</p><button @click="chang_edit('company')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'company'}" v-model="user_info.company"><button @click="saveUpdate('company')">保存</button></label>
					</li>
					<li>
						<label v-if="edit_item != 'occupation'"><p>{{user_info.occupation}}</p><button @click="chang_edit('occupation')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'occupation'}" v-model="user_info.occupation"><button @click="saveUpdate('occupation')">保存</button></label>
					</li>
					<li>
						<label v-if="edit_item != 'graduated_from'"><p>{{user_info.graduated_from}}</p><button @click="chang_edit('graduated_from')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'graduated_from'}" v-model="user_info.graduated_from"><button @click="saveUpdate('graduated_from')">保存</button></label>
					</li>
					<li>
						<label v-if="edit_item != 'time_graduation'"><p>{{user_info.time_graduation}}</p><button @click="chang_edit('time_graduation')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'time_graduation'}" v-model="user_info.time_graduation"><button @click="saveUpdate('time_graduation')">保存</button></label>
					</li>
					<li>
						<label v-if="edit_item != 'major'"><p>{{user_info.major}}</p><button @click="chang_edit('major')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'major'}" v-model="user_info.major"><button @click="saveUpdate('major')">保存</button></label>
					<li>
						<label v-if="edit_item != 'mailingAddress'"><p>{{user_info.mailingAddress}}</p><button @click="chang_edit('mailingAddress')">修改</button></label>
						<label v-else><input :class="{input_edit:edit_item == 'mailingAddress'}" v-model="user_info.mailingAddress"><button @click="saveUpdate('mailingAddress')">保存</button></label>
					</li>
					</label>
					</ul>
				</div>
			</div>
		</div>	
	</div>
</template>

<script>
	export default {
	  name: 'personInfo',
	  data () {
	    return {
			occupation:'student',
			user_info:{
			
			},
			user_info1:{
				userName:'Alan Walker',
				email:'12345678@qq.com',
				mobile:'12345678900',
				mailingAddress:'北京市东城区北蜂窝路121号一单元666室',
				occupation_stage:'student',
				universities:'清华大学',
				major:'土木工程',
				time_enrollment:'2018.9',
				studey_level:'本科',
			},
			user_info2:{
				userName:'Alan Walker',
				email:'12345678@qq.com',
				mobile:'12345678900',
				mailingAddress:'北京市东城区北蜂窝路121号一单元666室',
				occupation_stage:'teacher',
				company:'清华大学',
				occupation:'教师',
				graduated_from:'清华大学',
				time_graduation:'2018.1',
				major:'数学',
				academic_degree:'博士',
			},
			edit_item:'',
			
	    }
	  },
	  created: function () {
		  this.occupation=='student'?this.user_info = this.user_info1:this.user_info = this.user_info2
	  },
	  watch:{
		  occupation:function(){
			  this.occupation=='student'?this.user_info = this.user_info1:this.user_info = this.user_info2
		  }
	  },
	  methods:{
		  chang_edit:function(item){
			  this.edit_item = item
		  },
		  saveUpdate:function(item){
			  alert("保存"+ item +"修改")
			  this.edit_item = ''
		  }
	  }
	}
</script>

<style scoped="scoped">
	.info_content{
		width:600px;
		margin-left:100px;
		background-color: rgba(45,47,58,0.5);
		border-radius:20px;
		padding:30px;
	}
	.info_content_main{
		margin-top:20px;
		display: flex;
	}
	.info_content_main .info_content_main_left{
		width: 246px;
		display: table-caption;
	}
	.info_content_main .info_content_main_left ul{
		position: relative;
		zoom:1;
		overflow: hidden;
	}
	.info_content_main .info_content_main_left ul li{
		width: 240px;
		height: 50px;
		line-height: 50px;
		float: left;
		list-style: none;
		font-size: 14px;
		color:#C7C7C7;
		border-right: 1px rgba(65,65,65) solid;
	}
	.info_content_main_left_border{
		border-right:0 !important;
	}
	.info_content_main .info_content_main_right{
		width: 320px;
		float: right;
		margin-left: 30px;
	}
	.info_content_main .info_content_main_right ul{
		position: relative;
		zoom:1;
		overflow: hidden;
	}
	.info_content_main .info_content_main_right ul li {
		width: 320px;
		height: 50px;
		line-height: 50px;
		float: left;
		list-style: none;
	}
	.info_content_main .info_content_main_right ul li p{
		width: 240px;
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		color:#C7C7C7;
		overflow: hidden;
		white-space: nowrap;
		text-overflow: ellipsis;
		margin-top:10px;
		position: absolute;
	}	
	.info_content_main .info_content_main_right ul li input{
		width: 240px;
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		color:#E8E6E6;
		margin-top:10px;
		border:0;
		background: unset;
		text-indent: 10px;
	}
	.input_edit{
		background-color: #47474F !important;
		border-radius: 20px;
	}
	.info_content_main .info_content_main_right ul li button{
		float: right;
		width: 50px;
		height: 24px;
		line-height: 20px;
		margin-top:15px;
		border-radius: 20px;
		border:1px #fff solid;
		background: unset;
		font-size: 14px;
		color:#fff;
		
	}
	/* .info_content_main .info_content_main_right ul li button:hover{
		color:#000;
		background: #fff;
	} */
	.info_content_main_occupation{
		width:200px !important;
		margin-left: 60px;
	}	
	.info_content_main_occupation p{
		width: 98px !important;
		display:  inline-block;
		text-align: center;
		position: relative !important;
	}
	.info_occupation_active{
		color:#fff !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/personSet/personInfo.vue